import { Grid, Typography, Box, Stack } from '@mui/material';
import { ENVIRONMENT } from 'config';

const chunk = (arr, size = 2) =>
  arr.reduce((acc, _, i) => {
    if (i % size === 0) {
      acc.push({
        id: `set-${acc.length + 1}`,
        items: arr.slice(i, i + size),
      });
    }
    return acc;
  }, []);

const TabularFilterHeader = ({
  title,
  hotelName,
  isHotelSet = false,
  comparisonHotelName,
  isComparisonHotelSet = true,
  sections,
  chunkSize = 2,
  interpreterFragment = null,
}) => {
  const pairedSections = chunk(sections, chunkSize);
  return (
    <Box py={1} width="100%" mb={1} >
      <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
          <Typography fontWeight={600}> {title}</Typography>
        {ENVIRONMENT.IS_VISUAL_INTERPRETER_ENABLED?.toLowerCase() === 'true' && (
          <Grid item mt={1} mr={4}>
            {interpreterFragment}
          </Grid>
        )}
      </Stack>
      <Typography fontWeight="bold" mt={1} pl={2}>
        {comparisonHotelName ? (
          <>
            Selection Hotel{isHotelSet ? ' Set' : ''} (A):{' '}
            <Box component="span" fontWeight="bold">
              {hotelName}
            </Box>{' '}
            <br />
            Comparison Hotel{isComparisonHotelSet ? ' Set' : ''} (B):{' '}
            <Box component="span" fontWeight="bold">
              {comparisonHotelName}
            </Box>
          </>
        ) : (
          <>
            Hotel{isHotelSet ? ' Set' : ''} :{' '}
            <Box component="span" fontWeight="bold">
              {hotelName}
            </Box>
          </>
        )}
      </Typography>
      {chunkSize === 1 ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            flexDirection: 'row',
            pr: 24,
          }}
        >
          {pairedSections.map((set) =>
            set.items.map((section) => (
              <Typography variant="body2" key={section.id} mt={2}>
                {section.title}: {section.value}
              </Typography>
            ))
          )}
        </Box>
      ) : (
        <Grid container spacing={2} mt={1}>
          {pairedSections.map((set) => (
            <Grid item xs={12} sm={6} md={3} key={set.id}>
              {set.items.map((section) => (
                <Typography variant="body2" key={section.id} mt={2}>
                  {section.title}: {section.value}
                </Typography>
              ))}
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default TabularFilterHeader;
